import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IWalletWithdrawalRequest,
  IWalletWithdrawalInitialState,
} from "./walletWithdrawalModel";
import {
  getAllWalletWithdrawalRequest,
  updateWithdrawalRequest,
  getWalletWithdrawlRequestByID,
} from "./services/walletWithdrawal.services";

const initialState: IWalletWithdrawalInitialState = {
  loading: false,
  error: "",
  WalletWithdrawalID: null,
  WalletWithdrawalRequestList: [],
  WalletWithdrawalRequestDetails: {
    FilterFromDate: "",
    FilterToDate: "",
  },
  WithdrawalRequestDetails: {
    FilterFromDate: "",
    FilterToDate: "",
  },
};

const walletWithdrawalSlice = createSlice({
  name: "walletWithdrawal",
  initialState,
  reducers: {
    setWalletWithdrawalRequestDetails: (state, action) => {
      state.WalletWithdrawalRequestDetails = action.payload;
    },
    setWalletWithdrawalID: (state, action) => {
      state.WalletWithdrawalID = action.payload;
    },
    clearWalletWithdrawalID: (state) => {
      state.WalletWithdrawalID = initialState.WalletWithdrawalID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllWalletWithdrawalRequest.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllWalletWithdrawalRequest.fulfilled,
      (state, action: PayloadAction<IWalletWithdrawalRequest[]>) => {
        state.loading = false;
        state.WalletWithdrawalRequestList = action.payload || [];
      }
    );
    builder.addCase(getAllWalletWithdrawalRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WalletWithdrawalRequestList = [];
    });
    builder.addCase(updateWithdrawalRequest.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateWithdrawalRequest.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateWithdrawalRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getWalletWithdrawlRequestByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getWalletWithdrawlRequestByID.fulfilled,
      (state, action: any) => {
        state.loading = false;
        state.WithdrawalRequestDetails = action.payload;
      }
    );
    builder.addCase(getWalletWithdrawlRequestByID.rejected, (state, action) => {
      state.loading = false;
      state.WithdrawalRequestDetails = initialState.WithdrawalRequestDetails;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearWalletWithdrawalID,
  setWalletWithdrawalID,
  setWalletWithdrawalRequestDetails,
} = walletWithdrawalSlice.actions;
export default walletWithdrawalSlice.reducer;
